import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ImportComponent } from '../import.component';

@Component({
    selector: 'app-developer-import',
    templateUrl: './developer-import.component.html',
    styleUrls: ['./developer-import.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ImportComponent]
})
export class DeveloperImportComponent {
}
